import { Link } from "react-router-dom";
import DocumentDetail from "../../components/document/DocumentDetail";
import KnowledgeBase from "../../components/document/KnowledgeBase";
import LegacyAdminContent from "../../components/document/LegacyAdminContent";
import EmptyState from "../../components/common/EmptyState";
import type { Runtime } from "../../components/common/runtime";
import { t } from "../../i18n/index.js";

export const ADMIN_SECTIONS = ["agents", "typologies", "knowledge-base", "regulatory", "raci"];

const NAV = [
  { id: "overview", path: "/admin", key: "overview" },
  { id: "typologies", path: "/admin/typologies", key: "typologies" },
  { id: "knowledge-base", path: "/admin/knowledge-base", key: "knowledgeBase" },
  { id: "regulatory", path: "/admin/regulatory", key: "regulatory" },
  { id: "agents", path: "/admin/agents", key: "agents" },
  { id: "raci", path: "/admin/raci", key: "raci" },
];

export default function Documents({ runtime, path, revision, navigate, refresh }: {
  runtime: Runtime; path: string; revision: number;
  navigate: (path: string) => void; refresh: () => void;
}) {
  const [, , section = "overview", detailId] = path.split("/");
  const { getLocale, setLocale, LOCALES } = runtime.i18n;
  const documents = runtime.state.getState().kbDocuments;
  const document = detailId ? documents.find(item => item.id === detailId) : undefined;

  return <div className="admin-layout" id="view">
    <aside className="admin-side">
      <Link className="back-report" to="/">{t("admin.backToReport")}</Link>
      <img src="/seabird-tech-logo.svg" alt="Seabird Tech" />
      <span>{t("admin.title")}</span>
      <nav aria-label={t("admin.title")}>
        {NAV.map(item => <button key={item.id} className={section === item.id ? "active" : ""}
          aria-current={section === item.id ? "page" : undefined}
          onClick={() => navigate(item.path)}>{t(`admin.nav.${item.key}`)}</button>)}
      </nav>
      <button className="reset-admin" onClick={() => window.dispatchEvent(new CustomEvent("sfcr:reset"))}>
        {t("admin.resetDemo")}
      </button>
      <div className="lang-switch admin-lang-switch" role="group" aria-label={t("lang.switchLabel")}>
        {LOCALES.map(locale => <button type="button" key={locale} data-lang={locale}
          className={`lang-btn ${getLocale() === locale ? "active" : ""}`}
          onClick={() => setLocale(locale)}>{locale.toUpperCase()}</button>)}
      </div>
    </aside>

    <main className="admin-main">
      {section === "knowledge-base"
        ? (detailId
            ? (document
                ? <DocumentDetail document={document} onBack={() => navigate("/admin/knowledge-base")}
                    onOpenBlock={blockId => navigate(`/production#block-${blockId}`)} />
                : <EmptyState title={t("admin.kb.detail.missing")}
                    action={<button className="btn outline" onClick={() => navigate("/admin/knowledge-base")}>{t("admin.detail.back")}</button>} />)
            : <KnowledgeBase onOpen={id => navigate(`/admin/knowledge-base/${id}`)} onChanged={refresh} />)
        : <LegacyAdminContent section={section} detailId={detailId} revision={revision} navigate={navigate} />}
    </main>
  </div>;
}
